import { Tooltip } from '@material-ui/core';
import ConditionalWrapper from 'components/ConditionalWrapper/ConditionalWrapper';
import { type ReactNodeLike } from 'prop-types';
import { useTranslation } from 'react-i18next';

type LockedByGoodspeedZoneTooltipProps = {
  isActive: boolean;
  children: NonNullable<ReactNodeLike>;
};

const LockedByGoodspeedZoneTooltip = ({
  isActive,
  children,
}: LockedByGoodspeedZoneTooltipProps) => {
  const { t } = useTranslation();

  return (
    <ConditionalWrapper
      useWrapper={isActive}
      renderWrapper={wrapperChildren => (
        <Tooltip title={t('zones.disabledInputTooltip')}>
          <div>{wrapperChildren}</div>
        </Tooltip>
      )}
    >
      {children}
    </ConditionalWrapper>
  );
};

export default LockedByGoodspeedZoneTooltip;
